import React from 'react';
import '../styles/SuggestionsWidget.css'; // external CSS file

const SuggestionsWidget = ({ title, content }) => (
  <div className="suggestions-box">
    <h3>{title}</h3>
    <ul className="suggestions-list">
      {Array.isArray(content) ? content.map((item, index) => (
        <li key={index} className="suggestion-item">{item}</li>
      )) : <p>{content}</p>}
    </ul>
  </div>
);

export default SuggestionsWidget;
